export class Pubsub {
	constructor() {
		this.topics = {}
		this.subCount = 0;
	}

	sub(name, cb) {
		const id = this.subCount++
		this.topics[name] = this.topics[name] || [];
		this.topics[name].push({
			id,
			cb
		})
		return id
	}

	unsub(id) {
		Object.keys(this.topics).forEach(k => {
			this.topics[k] = this.topics[k].filter(t => t.id !== id)
		})
	}

	pub(name, args) {
		if (!this.topics[name]) { return }
		this.topics[name].forEach(sub => {
			sub.cb(args)
		})
	}
}


export const pubsub = window.pubsub = new Pubsub();